import { render, staticRenderFns } from "./sendmessage.html?vue&type=template&id=19356634&scoped=true&external"
import script from "./sendmessage.vue?vue&type=script&lang=js"
export * from "./sendmessage.vue?vue&type=script&lang=js"
import style0 from "./sendmessage.vue?vue&type=style&index=0&id=19356634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19356634",
  null
  
)

export default component.exports